import React from 'react';
import ReactDOM from 'react-dom/client';

import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import 'aos/dist/aos.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import './index.css';

import reportWebVitals from './reportWebVitals';
import App from './App';
import { VendorProvider } from 'contexts/vendor.context';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <VendorProvider>
    <App />
  </VendorProvider>
);

reportWebVitals();
